/** sessionStorage: all-projects Gantt expand sets (missing key = none expanded). */

export const GANTT_EXPANDED_SECTIONS_STORAGE_KEY = 'pm-hub-group-timeline-expanded-sections';
export const GANTT_EXPANDED_GROUPS_STORAGE_KEY = 'pm-hub-group-timeline-expanded-groups';
export const GANTT_LEFT_WIDTH_STORAGE_KEY = 'pm-hub-gantt-left-width';
export const GANTT_LEFT_WIDTH_DEFAULT = 300;
export const GANTT_LEFT_WIDTH_MIN = 220;
export const GANTT_LEFT_WIDTH_MAX = 720;

export function clampGanttLeftWidth(width: number): number {
  if (!Number.isFinite(width)) return GANTT_LEFT_WIDTH_DEFAULT;
  return Math.min(GANTT_LEFT_WIDTH_MAX, Math.max(GANTT_LEFT_WIDTH_MIN, Math.round(width)));
}

export function readStoredGanttLeftWidth(): number {
  try {
    const raw = sessionStorage.getItem(GANTT_LEFT_WIDTH_STORAGE_KEY);
    if (raw == null) return GANTT_LEFT_WIDTH_DEFAULT;
    return clampGanttLeftWidth(Number(raw));
  } catch {
    return GANTT_LEFT_WIDTH_DEFAULT;
  }
}

export function storeGanttLeftWidth(width: number): void {
  try {
    sessionStorage.setItem(GANTT_LEFT_WIDTH_STORAGE_KEY, String(clampGanttLeftWidth(width)));
  } catch {
    /* quota / private-mode */
  }
}

function readJsonStringArray(key: string): string[] | null {
  try {
    const raw = sessionStorage.getItem(key);
    if (raw == null) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id): id is string => typeof id === 'string' && id.length > 0);
  } catch {
    return null;
  }
}

function writeJsonStringArray(key: string, ids: readonly string[]): void {
  try {
    sessionStorage.setItem(key, JSON.stringify([...ids]));
  } catch {
    /* quota / private-mode */
  }
}

/** `null` means the key was never written — collapse-first. */
export function readStoredExpandedIdSet(key: string): Set<string> | null {
  const ids = readJsonStringArray(key);
  if (ids == null) return null;
  return new Set(ids);
}

export function storeExpandedIdSet(key: string, ids: Iterable<string>): void {
  writeJsonStringArray(key, Array.from(ids));
}

export function collapsedIdsFromExpanded(
  allIds: readonly string[],
  expanded: ReadonlySet<string> | null,
): Set<string> {
  if (!expanded) return new Set(allIds);
  return new Set(allIds.filter((id) => !expanded.has(id)));
}

export function expandedIdsFromCollapsed(
  allIds: readonly string[],
  collapsed: ReadonlySet<string>,
): Set<string> {
  return new Set(allIds.filter((id) => !collapsed.has(id)));
}

export function toggleIdInSet(prev: ReadonlySet<string>, id: string): Set<string> {
  const next = new Set(prev);
  if (next.has(id)) next.delete(id);
  else next.add(id);
  return next;
}
